import { action } from 'easy-peasy';
import initStore from '../initStore';
import { IActionReset } from '../types';

const reset: IActionReset = action(state => {
  const { items, pagination } = initStore;

  state.items = items;
  state.pagination = pagination;
});

export default reset;
